import ResourceService from './resource.service'

class CompanyProfileService extends ResourceService {
  static get resource() {
    return 'company-profile'
  }
}

export default CompanyProfileService
